<template>
  <div>
    
    <div class="firstValue" v-if="history.length > 0 ">
      <span class="lastStatus" :style="{borderColor: history[0].CustomerDraftIssuesStatus ? history[0].CustomerDraftIssuesStatus.colorCode : '', color: history[0].CustomerDraftIssuesStatus ? history[0].CustomerDraftIssuesStatus.colorCode : ''}">{{ history[0].CustomerDraftIssuesStatus ? history[0].CustomerDraftIssuesStatus.name : ''}}</span>
      <span class="m-l-10">
        {{ history[0].createdAt | moment("from", "now") }}
      </span>
    </div>
    
  </div>
</template>

<script>
  export default {
    props: {
      history: {
        type: Array,
        default: () => ([])
      }
    }
  }
</script>

<style lang="scss" scoped>
  .lastStatus{
    display: inline-block;
    padding: 5px 10px;
    border-radius: 5px;
    color: #fff;
    border: 2px solid;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 13px;
  }
</style>